// extracted by mini-css-extract-plugin
export default {"nested-menu-item__right-icon":"nested-menu-item_nested-menu-item__right-icon__qOzsw"};